import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_COMPANY_PROFILE } from "../../../common/URLs";

export const fetchProfile = async () => {
  try {
    const token = await fetchToken()

    const response = await fetch(
      `${BASE_URL}/${EMPLOYER}/${EMPLOYER_COMPANY_PROFILE}`,
      // "https://api.indiahirings.com/employer/employer-company-profile",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    // console.log("data from API", data);
    return data;
  } catch (error) {
    return error;
  }
};

export const updateProfile = async (uuid, data) => {
  try {
    // console.log("data in update api:- ", data);
    const token = await fetchToken()

    const response = await fetch(
      `${BASE_URL}/${EMPLOYER}/${EMPLOYER_COMPANY_PROFILE}/${uuid}`,
      {
        method: "PUT",
        headers: {
          // Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    return error;
  }
};
